import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <main className="min-h-screen bg-background-50 text-foreground-950 flex flex-col items-center justify-center text-center px-5">
      <p className="text-[12px] tracking-[0.2em] uppercase text-foreground-600 font-medium">Page not found</p>
      <h1 className="mt-5 text-[34px] md:text-[48px] leading-[1.08] font-medium tracking-[-0.02em]">
        This page isn&rsquo;t <span className="em-serif">here.</span>
      </h1>
      <p className="mt-5 text-[16px] leading-relaxed text-foreground-700 max-w-md">
        The page you&rsquo;re looking for may have moved or no longer exists.
      </p>
      <Link
        to="/"
        className="mt-8 inline-flex items-center h-12 px-7 rounded-full bg-primary-500 text-background-50 text-[15px] font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500"
      >
        Back to Daywell Living
      </Link>
    </main>
  );
}